<!--<div *ngIf="!menuActive || (menuActive && searchOpen)">
  <ng-content select="[action-bar]"></ng-content>
</div>-->
<ng-content select="[action-bar]"></ng-content>

<div class="topbar-sticky-container" [ngClass]="scrollDirection" [class.is--fixed]="fixed" #topbarContainer>
  <div
    class="topbar"
    [class.is--fixed]="fixed"
    [class.is--open]="menuActive"
    [class.has--bar-overlay]="searchOpen"
    [class.subnav--active]="activeSubmenu"
    (mouseleave)="activeSubmenu = ''; setFixed()"
    #topbar
  >
    <div class="topbar__inner" [class.is--transparent]="transparent">
      <!-- Main nav -->
      <div class="container">
        <div class="topbar__bar" (mouseover)="activeSubmenu = ''">
          <div>
            <button class="hamburger d-xl-none" [class.is--active]="menuActive" [class.is--light]="themeLight" (click)="toggleMobileMenu()">
              <span class="hamburger__lines"></span>
            </button>
          </div>
          <span class="topbar__bar__logo mb-0">
            <h1 *ngIf="url === '/'" class="sr-only">{{ 'meta-titel-suffix' | fromDictionary }}</h1>

            <a [routerLink]="['/']" class="d-block">
              <ng-container *ngIf="!themeLight">
                <img
                  class="d-none d-xl-block"
                  [src]="storefront?.logoLarge || '/assets/gfx/kadodesign-logo-staand.svg'"
                  alt="Kado Design"
                />
                <img
                  class="d-block d-xl-none"
                  [src]="storefront?.logoSmall || '/assets/gfx/kadodesign-logo-liggend.svg'"
                  alt="Kado Design"
                />
              </ng-container>
              <ng-container *ngIf="themeLight">
                <img
                  class="d-none d-xl-block"
                  [src]="storefront?.logoLarge || '/assets/gfx/kadodesign-logo-staand-wit.svg'"
                  alt="Kado Design"
                />
                <img
                  class="d-block d-xl-none"
                  [src]="storefront?.logoSmall || '/assets/gfx/kadodesign-logo-liggend-wit.svg'"
                  alt="Kado Design"
                />
              </ng-container>
            </a>
          </span>

          <div class="topbar__bar__actions">
            <button class="button button-link button--muted-light" (click)="openSearch()">
              <app-icon anchor="icon-search"></app-icon>
              <span class="sr-only">{{ 'topbar-zoeken-label' | fromDictionary }}</span>
            </button>
            <a [routerLink]="['/account']" class="button button-link button--muted-light">
              <app-icon anchor="icon-user"></app-icon>
              <span class="button__label">{{ 'topbar-account-label' | fromDictionary }}</span>
            </a>

            <a [routerLink]="['/cart']" class="button button-link button--muted-light button--cart">
              <span class="chip chip--xs" *ngIf="cartCount && !menuActive">{{ cartCount }}</span>
              <app-icon anchor="icon-shopping-cart"></app-icon>
              <span class="button__label">{{ 'topbar-winkelmand-label' | fromDictionary }}</span>
            </a>

            <ng-content select="[language-bar]"></ng-content>
          </div>
        </div>
        <nav class="topbar__nav">
          <!-- Main -->
          <ul class="topbar__nav__list" [class.has--a-lot]="menu.length > 6">
            <li
              class="topbar__nav__list__item hovering"
              *ngFor="let page of menu | ofMenuType: 'MenuItem'"
              [hoverDelay]="200"
              (hoverDelayComplete)="page.menuItems.length ? (activeSubmenu = page.guid) : (activeSubmenu = '')"
            >
              <a
                *ngIf="page.routerLink?.length"
                class="topbar__nav__list__item__link"
                [class.is--current]="activeSubmenu === page.guid"
                (click)="routeTo(page, $event)"
                [routerLink]="page.routerLink"
                [routerLinkActive]="'is--active'"
                [ngStyle]="{ 'pointer-events': page.url === '#' ? 'none' : '' }"
              >
                {{ page?.title }}
              </a>
              <a
                *ngIf="!page.routerLink?.length"
                class="topbar__nav__list__item__link"
                [class.is--current]="activeSubmenu === page.guid"
                (click)="routeTo(page, $event)"
                [href]="page.url"
                target="_blank"
                [ngStyle]="{ 'pointer-events': page.url === '#' ? 'none' : '' }"
              >
                {{ page?.title }}
              </a>
            </li>
          </ul>
        </nav>
      </div>

      <!-- Navbar overlay: search -->
      <div class="topbar__overlay" *ngIf="searchOpen">
        <app-search-bar></app-search-bar>
      </div>
    </div>

    <!-- Subnav -->
    <nav
      class="topbar__expansion-panel"
      [class.is--mouseover]="activeSubmenu.length && ActiveMenuHasSubmenu"
      [class.is--active]="menuActive"
    >
      <ul class="container topbar__expansion-panel__inner" id="panel" *ngIf="!searchOpen">
        <li
          class="subnav-list"
          *ngFor="let page of repeatLists(menu)"
          [class.hide--mobile]="activeSubmenuMobile && activeSubmenuMobile !== page.guid"
        >
          <button
            class="subnav-list__mobile-toggle h3"
            (click)="setActiveMobileMenu(page)"
            [class.is--active]="page.guid === activeSubmenuMobile"
          >
            <div class="subnav-list__mobile-toggle__inner">
              <span class="truncate">{{ page?.title }}</span>
              <app-icon
                class="icon-xxs mt-2 subnav-list__mobile-toggle__icon"
                *ngIf="page.menuItems.length"
                anchor="icon-chevron-right"
              ></app-icon>
            </div>
          </button>
          <ul
            class="subnav-list__item"
            [class.is--active]="page.guid === activeSubmenu"
            [class.is--mobile-active]="page.guid === activeSubmenuMobile"
          >
            <li class="nav" *ngFor="let subMenu of page.menuItems | ofMenuType: 'MenuItem'">
              <a class="nav__title" [routerLink]="subMenu.url" [routerLinkActive]="'is--current'">
                {{ subMenu?.title }}
              </a>

              <ul class="nav__list">
                <li class="nav__list__item" *ngFor="let item of subMenu.menuItems | ofMenuType: 'MenuItem'">
                  <a class="nav__list__item__link" [routerLink]="item.url" [routerLinkActive]="'text-decoration-underline'">
                    {{ item.title }}
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </nav>

    <div class="topbar__expansion-panel-v2" *ngIf="searchOpen" id="panel">
      <app-search-results></app-search-results>
    </div>
  </div>
</div>
